import script from "./oauth.vue?vue&type=script&setup=true&lang=js"
export * from "./oauth.vue?vue&type=script&setup=true&lang=js"

import "./oauth.vue?vue&type=style&index=0&id=6ac9b34c&lang=scss&scoped=true"

import exportComponent from "D:\\yunchi\\yc\\yc-vue-source\\new-energy\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6ac9b34c"]])

export default __exports__